import React from "react";
import { styled } from "@mui/material";
import { isProduction } from "fe-common/utils/envGetter";
import EnhancedTable, {
  EnhancedTableColumn,
} from "fe-common/ui/table/enhancedTable";

//region [[ Styles ]]
interface ReportTableProps {
  reportData: any[];
  columns: EnhancedTableColumn[];
  expandedRowContent?: (row: any) => React.ReactElement | React.ReactElement[];
  rtlView?: boolean;
}

const MessageDiv = styled("div")({
  margin: "80px 0",
  fontWeight: "bold",
  paddingBottom: 8,
  textAlign: "center",
});
//endregion [[ Styles ]]

//region [[ Props ]]

//endregion [[ Props ]]
//region [[ Functions ]]
const openInDialogue = (sessionId: string, ragApp?: string) => {
  const url = `${
    isProduction()
      ? "https://dialogue.kahun.com/"
      : "https://dialogue-dev.kahun.com/"
  }${ragApp ? "app/" + ragApp + "/" : ""}${sessionId}`;
  window.open(url, "_blank");
};

//endregion [[ Functions ]]
export const ReportTable = ({
  reportData,
  columns,
  expandedRowContent,
  rtlView,
}: ReportTableProps) => {
  return (
    <>
      {reportData?.length > 0 && (
        <MessageDiv
          style={{
            borderBottom: "1px solid #ddd",
            margin: "8px 0",
          }}
        >
          Total: {reportData.length}
        </MessageDiv>
      )}
      {!reportData ? (
        <MessageDiv>Please press 'Generate' to create the report</MessageDiv>
      ) : !reportData.length ? (
        <MessageDiv>No exchanges found.</MessageDiv>
      ) : (
        <EnhancedTable
          data={reportData}
          columns={columns}
          expandedIndices={[]}
          expandedRowContent={expandedRowContent}
          defaultRowsPerPage={50}
          rtlview={rtlView}
          fixedHeader
          hideChecked
          hideToolbar
          expandedRowIndicator={true}
        />
      )}
    </>
  );
};
